import { render, staticRenderFns } from "./ProjectProperty.vue?vue&type=template&id=8bf77c7e&"
import script from "./ProjectProperty.vue?vue&type=script&lang=js&"
export * from "./ProjectProperty.vue?vue&type=script&lang=js&"
import style0 from "./ProjectProperty.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports